import React from 'react';
import { Button } from '@thd-olt-component-react/core-ui';
import { Tooltip } from '@thd-olt-component-react/tooltip';
import PropTypes from 'prop-types';
import { Email } from '@one-thd/sui-icons';
import { clickEvents } from '../../../../utils/analytics';
import { isValidEmail } from '../../../../utils/validations';
import { markCandidateAsEmailed } from '../../../../api/SlmService';

import './ContactButtons.scss';

const EmailMeButton = ({ email, candidateId, type = 'primary' }) => {

  const markAsViewed = () => {
    markCandidateAsEmailed(candidateId).catch((error) => {
      console.error('Error marking candidate as contacted', error);
    });
  };

  const handleClick = () => {
    clickEvents.candidatePageInteraction('contact', 'email', candidateId);
    markAsViewed();
  };

  if (!isValidEmail(email)) {
    return (
      <div className="contact-button">
        <Button disabled className="contact-button__btn">
          <span className="contact-button__icon">
            <Email size="small" />
          </span>
          <span className="contact-button__label">
            Email
          </span>
        </Button>
      </div>
    );
  }

  return (
    <div className="contact-button">
      <Tooltip
        channel="desktop"
        closeButton
        content={(
          <div className="contact-button__tooltip" data-testid="email-me-btn-tooltip">
            {email || ''}
          </div>
        )}
        showClose={false}
      >
        <a
          href={`mailto:${email}`}
          className="slm__link-no-underline"
        >
          <div
            onClick={handleClick}
            className={`contact-button__btn ${type}`}
          >
            <span className="contact-button__icon">
              <Email
                size="small"
              />
            </span>
            <span className="contact-button__label">
              Email
            </span>
          </div>
        </a>
      </Tooltip>
    </div>
  );
};

EmailMeButton.propTypes = {
  email: PropTypes.string.isRequired,
  candidateId: PropTypes.number.isRequired
};

export default EmailMeButton;
